import { useState } from 'react'
import { STEP_LABELS, type StepId } from '@/app/receivable/workflow/receivable-steps'
import type { WizardStepGroupNavState } from '@klear/ui/wizard/nav-state'
import { Wizard } from '@klear/ui/wizard/wizard'
import { ReceivableFlow } from '@/app/receivable/workflow/receivable-flow'
import { useReceivableWizard } from '@/app/receivable/workflow/useReceivableWizard'

export type ReceivableWizardProps = {
  traderIdParam: string
  orderIdSeed?: number | null
  onBack: () => void
}

export default function ReceivableWizard({ traderIdParam, orderIdSeed, onBack }: ReceivableWizardProps) {
  const workflow = useReceivableWizard({ traderIdParam, orderIdSeed: orderIdSeed ?? null })
  const [nav, setNav] = useState<WizardStepGroupNavState | null>(null)

  const activeStepId = nav?.activeStepId ?? ''
  const activeStepLabel = STEP_LABELS[activeStepId as StepId] ?? activeStepId

  return (
    <div className="flex min-h-0 flex-1 flex-col overflow-hidden">
      <Wizard
        name="Receivable"
        subtitle={activeStepLabel}
        steps={nav?.steps ?? []}
        activeStepId={activeStepId}
        onStepSelect={nav?.onStepSelect}
        isStepDisabled={nav?.isStepDisabled}
        onBack={onBack}
        backLabel="Exit"
      >
        <ReceivableFlow workflow={workflow} orderIdSeed={orderIdSeed} onNavStateChange={setNav} />
      </Wizard>
    </div>
  )
}
